import React from "react";

import type { LineVariant } from "../../types";

import { useStyles } from "./line.styles";

interface Props {
  class_name?: string;
  variant?: LineVariant;
}

export const Line: React.FC<Props> = ({ class_name, variant = "solid" }) => {
  const { cx, classes } = useStyles();

  return (
    <svg
      className={cx(classes.line, class_name)}
      width="2"
      height="0"
      viewBox="0 0 1 1"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <line
        x1="0.5"
        y1="0"
        x2="0.5"
        y2="1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray={variant === "dashed" ? "4 6" : undefined}
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};
